import { getSubgroupsFromDayDate } from '../getSubgroupsFromDayDate';

import { checkIsStringedDatesListValid, formatDate, WeekParity } from '.';

export const subgroupNumber = ({
  weekParity,
  dayDate,
  searchingDate,
}: {
  weekParity: WeekParity;
  dayDate: string;
  searchingDate?: Date;
}): number | null => {
  const evenName = 'чет';
  const oddName = 'неч';
  const formattedDayDate = dayDate.trim().toLowerCase();
  if (
    formattedDayDate === evenName ||
    formattedDayDate === oddName ||
    formattedDayDate === ''
  ) {
    return null;
  } else {
    if (
      formattedDayDate.includes(oddName) ||
      formattedDayDate.includes(evenName)
    ) {
      if (formattedDayDate === 'чет/неч') {
        return weekParity === WeekParity.Even ? 1 : 2;
      } else if (formattedDayDate === 'неч/чет') {
        return weekParity === WeekParity.Odd ? 1 : 2;
      } else if (formattedDayDate === 'чет/') {
        return weekParity === WeekParity.Even ? 1 : null;
      } else if (formattedDayDate === 'неч/') {
        return weekParity === WeekParity.Odd ? 1 : null;
      } else if (formattedDayDate === '/чет') {
        return weekParity === WeekParity.Even ? 2 : null;
      } else if (formattedDayDate === '/неч') {
        return weekParity === WeekParity.Odd ? 2 : null;
      }
    }

    if (formattedDayDate.includes('/')) {
      let isShowByDatesForSubgroup1 = false;
      let isShowByDatesForSubgroup2 = false;

      if (searchingDate) {
        const subgroups = getSubgroupsFromDayDate(dayDate);
        if (subgroups.length === 2) {
          const [subgroup1, subgroup2] = subgroups;
          const date1 = formatDate(searchingDate, 'dd.MM');
          const date2 = formatDate(searchingDate, 'd.MM');
          isShowByDatesForSubgroup1 = subgroup1.some(
            (d) => d === date1 || d === date2,
          );
          isShowByDatesForSubgroup2 = subgroup2.some(
            (d) => d === date1 || d === date2,
          );
        }
      }

      const splittedDayDate = formattedDayDate.split('/');
      const splittedDayDates1 = splittedDayDate[0];
      const splittedDayDates2 = splittedDayDate[1];
      const splittedDayDates1BySpace = splittedDayDates1.split(' ');
      const splittedDayDates2BySpace = splittedDayDates2.split(' ');
      const isSplittedDayDates1BySpaceValid = checkIsStringedDatesListValid(
        splittedDayDates1BySpace,
      );
      const isSplittedDayDates2BySpaceValid = checkIsStringedDatesListValid(
        splittedDayDates2BySpace,
      );

      if (isSplittedDayDates1BySpaceValid && splittedDayDates2.trim() === '') {
        isShowByDatesForSubgroup1 = true;
      }
      if (isSplittedDayDates2BySpaceValid && splittedDayDates1.trim() === '') {
        isShowByDatesForSubgroup2 = true;
      }

      if (isShowByDatesForSubgroup1 && isShowByDatesForSubgroup2) {
        return null;
      } else if (isShowByDatesForSubgroup1 && !isShowByDatesForSubgroup2) {
        return 1;
      } else if (!isShowByDatesForSubgroup1 && isShowByDatesForSubgroup2) {
        return 2;
      }
    }
  }
  return null;
};
